import { render, staticRenderFns } from "./VotingRegistrationForms.vue?vue&type=template&id=86f47e60&"
import script from "./VotingRegistrationForms.vue?vue&type=script&lang=js&"
export * from "./VotingRegistrationForms.vue?vue&type=script&lang=js&"
import style0 from "./VotingRegistrationForms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports